import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { PUBLIC_URL } from './config/settings/environment'
import routes from './config/settings/routes'
import NotFoundPage from './pages/NotFound'
import SearchBuyerPage from './pages/SearchBuyer'

/**
 * The Routing's component.
 */
const Routing = () => (
  <BrowserRouter basename={PUBLIC_URL}>
    <Routes>
      <Route caseSensitive element={<SearchBuyerPage />} path={routes.searchBuyer} />
      <Route element={<NotFoundPage />} path="*" />
    </Routes>
  </BrowserRouter>
)

export default Routing
